module.exports = __webpack_public_path__ + "img/deodorizerHome_green.65696000.svg";